import { StrictMode } from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { App } from './app';
import './styles.css';

const root = document.getElementById('root')!;
const app = (
  <StrictMode>
    <App />
  </StrictMode>
);
// Vorgerenderte Plattform-Seiten (landing.html usw.) bringen ihr HTML schon mit – dann nur noch beleben.
if (root.hasChildNodes()) hydrateRoot(root, app);
else createRoot(root).render(app);
